import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AzimuthToolService } from 'src/app/map/services/azimuth-tool.service';
import { RangeRingToolService } from 'src/app/map/services/range-ring-tool.service';
import { TerrainHeightService } from 'src/app/map/services/terrain-height.service';
import { ConfigurationRCSModel } from 'src/app/models/configuration';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { CrossSectionService } from 'src/app/services/cross-section.service';
import { HorizonToolService } from 'src/app/services/horizon-tool.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { MultipathToolService } from 'src/app/services/multipath-tool.service';
import { PointsService } from 'src/app/services/points.service';
import { ProjectService } from 'src/app/services/project.service';
import { TerrainGridService } from 'src/app/services/terrain-grid.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { UtilsService } from 'src/app/services/utils.service';
import * as olProj from 'ol/proj';
import { DistanceAzimuthService } from 'src/app/map/services/distance-azimuth.service';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { ObstacleDataService } from 'src/app/services/obstacle-data.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { GritProjectService } from 'src/app/services/grit/grit.project.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-rcs',
  templateUrl: './rcs.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class RcsComponent implements OnInit {

  @ViewChild('ngForm') form!: NgForm;

  configurationController : ConfigurationService;

  primaryDataActive : boolean = false;
  secondaryDataActive : boolean = true;

  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private utilsService : UtilsService,
    public bsModalRef : BsModalRef,
    public coordenatesController : CoordenateService,
    private pointService : PointsService,
    private calculationsService : CalculationsService,
    private modalService : ModalControlService,
    private mapService : MapService,
    private userSettingsService: UserSettingsService,
    private azimuthToolService: AzimuthToolService,
    private rangeRingToolService: RangeRingToolService,
    private crossSectionToolService: CrossSectionService,
    private horizonToolService: HorizonToolService,
    private multipathToolService: MultipathToolService,
    private terrainGridService: TerrainGridService,
    private distanceAzimuthService: DistanceAzimuthService,
    private saamTrafficService: SaamTrafficService,
    private obstacleDataService: ObstacleDataService,
    private routeSegmentsService: RouteSegmentsService,
    private gritProjectService: GritProjectService
    ) {
      this.configurationController = configurationController;
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    for (const newRcs of this.configurationController.currentConfiguration.rcs){
      const oldRcs = this.configurationController.tempConfiguration.rcs.find(rcs => rcs.id == newRcs.id);
      if (!oldRcs) {
        continue;
      }
      if (oldRcs.enabled != newRcs.enabled) {
        newRcs.enabled = oldRcs.enabled;
        this.configurationController.updateCoordenateControlRCSList();
      }
    }

    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration():void {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }
    this.configurationController.saveConfigurationPopup(this.form);
    this.bsModalRef.hide();
  }

  enableRCS(): void{
    this.configurationController.currentConfiguration.rcs.forEach(element => {
      if(element.isselected){
        element.enabled = true;
      }
    });
    this.configurationController.updateCoordenateControlRCSList();
  }
  disableRCS(): void{
    let warning : boolean = false;
    for (let element of this.configurationController.currentConfiguration.rcs) {
      if(element.isselected){
        if (!element.isactive){
          element.enabled = false;
        }else {
          warning = true;
          break;
        }
      }
    };
    if (warning) {
      this.modalService.showMesssageModal("Warning", "You cannot delete an active RCS. Please deactivate it if you want to disable the selected RCS.");
      warning = false;
    } else {
      this.configurationController.updateCoordenateControlRCSList();
    }
  }

  activatePrimaryData() : boolean {
    this.primaryDataActive = true;
    this.secondaryDataActive = false;
    return false;
  }

  activateSecondaryData() : boolean {
    this.primaryDataActive = false;
    this.secondaryDataActive = true;
    return false;
  }

  activateRCS(rcs: ConfigurationRCSModel): void{
    if (this.projectService.projectEditable()) {
      this.configurationController.saveConfigurationPopup(this.form);
    }
    let rcspreviousActive :string = this.coordenatesController.getActiveRCS().epsg;
    if(!rcs.isactive){
      this.coordenatesController.setRCSActive(rcs);
      this.pointService.reprojectMap(rcs.epsg);
      //#region GRIT
      this.gritProjectService.clean();
      this.gritProjectService.get(this.projectService.activeProject);
      // this.interferenceTestService.activateProject(project.id == 1);
      // this.pointService.fetchAndAddInterferenceTest();
      // this.pointService.fetchAndAddRadars();
      // this.pointService.fetchAndAddDevices();
      //endregion
      this.routeSegmentsService.loadState(this.projectService.activeProject.id);
      this.obstacleDataService.loadState(this.projectService.activeProject.id);
      this.userSettingsService.userSettings.epsg = rcs.epsg;
      this.userSettingsService.updateSettings();

      //this.mapService.changeMousePointerProjection(rcs.epsg);
      //this.annotationService.reprojectAnnotations(rcs.epsg);
      const calculationLayer = this.calculationsService.getCalculationsLayer();
        for (let i = 0; i<calculationLayer.childLayers.length; i++){
          this.calculationsService.getCalculationsLayer().deleteLayer(calculationLayer.childLayers[i]);
          i--;
        }
      this.calculationsService.reprojectCalculations(rcs.epsg);

      // reproject tools
      this.multipathToolService.reproject(rcspreviousActive);
      this.azimuthToolService.drawAngles();
      this.rangeRingToolService.drawCircles();
      this.crossSectionToolService.reproject(rcspreviousActive);
      this.horizonToolService.reproject();
      this.terrainGridService.reproject(rcspreviousActive);
      this.distanceAzimuthService.reproject(rcspreviousActive);
      this.saamTrafficService.reproject(rcspreviousActive);
      //reproject overlays
      this.mapService.getMap('map').getOverlays().forEach(overlay=>
        overlay?.setPosition(olProj.transform(overlay.getPosition(),rcspreviousActive,this.mapService.getMap('map').getView().getProjection().getCode()))
      )
    }
  }

}
